import { render, staticRenderFns } from "./BrowserStats.vue?vue&type=template&id=5132c981&scoped=true&"
import script from "./BrowserStats.vue?vue&type=script&lang=js&"
export * from "./BrowserStats.vue?vue&type=script&lang=js&"
import style0 from "./BrowserStats.vue?vue&type=style&index=0&id=5132c981&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132c981",
  null
  
)

export default component.exports